import { ActivationScreenEvents } from '../Typescript'
import Config from '../Data/Config.json'

type TrackAuthEvent = {
    trackEventType: ActivationScreenEvents
    mvpdId?: string
}

export class AppMeasurements {
    private _defaultDevice = 'firetv'
    private _device = ''

    constructor() {
        const pathname = window.location.pathname
        this._device =
            Config.supportedDevices.find((device: string) => pathname.includes(device)) ||
            this._defaultDevice
    }

    start(trackEventType: ActivationScreenEvents) {
        const customEvent = new CustomEvent('activationPageLoaded', { detail: trackEventType })
        setTimeout(() => {
            window.dispatchEvent(customEvent)
        }, 500)
    }

    trackAuthEvent(eventData: TrackAuthEvent) {
        const additionalVars = {
            'tve.app': this._device,
        }
        const customEvent = new CustomEvent('activationPageTrackAuthEvent', {
            detail: { ...eventData, additionalVars },
        })
        window.dispatchEvent(customEvent)
    }
}

export default new AppMeasurements()
